import { FC, useContext, useEffect, useState } from "react";
import { InstanceContext } from "../../context/InstanceContext";
import styles from "./index.module.css";

interface IProps {
  licenseId: string;
  onClose: () => void;
}

const ActivateModal: FC<IProps> = ({ licenseId, onClose }) => {
  /* MSP instances the user has a role in — the provisioning continues in one of these. */
  const { instancesWithRole } = useContext(InstanceContext);
  const mspOptions = instancesWithRole.filter((m) => m.domain && m.domain !== "*");

  const [selectedMsp, setSelectedMsp] = useState<string>("");

  /* Default the selection to the first available instance. */
  useEffect(() => {
    if (!selectedMsp && mspOptions.length > 0) {
      setSelectedMsp(mspOptions[0].id);
    }
  }, [mspOptions, selectedMsp]);

  const handleContinue = () => {
    const msp = mspOptions.find((m) => m.id === selectedMsp);
    if (!msp) return;
    const base = msp.domain.startsWith("http") ? msp.domain : `https://${msp.domain}`;
    window.location.href = `${base}/provisioning/${licenseId}`;
  };

  return (
    <div className={styles["modal-overlay"]}>
      <div className={styles["modal"]} onClick={(e) => e.stopPropagation()}>
        <button className={styles["modal-close"]} onClick={onClose} aria-label="Close">
          ×
        </button>
        <h3 className={styles["modal-title"]}>Choose where to activate</h3>

        <div className={styles["modal-body"]}>
          <p className={styles["waiting-sub"]} style={{ marginBottom: 16 }}>
            Select the MSP to provision this device into. You'll continue setup in that portal.
          </p>
          <p style={{ color: "red", marginBottom: 16, fontSize: 14 }}>
            Note: Please upgrade your target MSP to 2.11.1 to activate this box.
          </p>

          {mspOptions.length === 0 ? (
            <p className={styles["modal-error"]}>You have no MSP instances available.</p>
          ) : (
            <div className={styles["msp-list"]}>
              {mspOptions.map((m) => (
                <label
                  key={m.id}
                  className={`${styles["msp-option"]} ${selectedMsp === m.id ? styles["msp-option-active"] : ""}`}
                >
                  <input
                    type="radio"
                    name="msp"
                    value={m.id}
                    checked={selectedMsp === m.id}
                    onChange={() => setSelectedMsp(m.id)}
                  />
                  <span className={styles["msp-name"]}>{m.name}</span>
                  <span className={styles["msp-domain"]}>{m.domain}</span>
                </label>
              ))}
            </div>
          )}
        </div>

        <div className={styles["modal-footer"]}>
          <button
            className={styles["modal-confirm"]}
            onClick={handleContinue}
            disabled={!selectedMsp || mspOptions.length === 0}
          >
            Continue
          </button>
        </div>
      </div>
    </div>
  );
};

export default ActivateModal;
